import type { Exercise, Taxonomy, WorkoutPlan } from "./types";

export const languageLabels = {
  en: "English",
  es: "Español",
  it: "Italiano",
  tr: "Türkçe",
  ru: "Русский",
  zh: "中文"
} as const;

export const defaultPlan: WorkoutPlan = {
  version: 1,
  days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((name, index) => ({
    id: `day-${index + 1}`,
    name,
    items: []
  }))
};

export function preferredLanguage(): keyof typeof languageLabels {
  return navigator.language.toLowerCase().startsWith("zh") ? "zh" : "en";
}

export async function loadExerciseData(): Promise<{ exercises: Exercise[]; taxonomy: Taxonomy }> {
  const [exerciseResponse, taxonomyResponse] = await Promise.all([
    fetch("/data/exercises.json"),
    fetch("/data/taxonomy.json")
  ]);

  if (!exerciseResponse.ok || !taxonomyResponse.ok) {
    throw new Error("Unable to load exercise data");
  }

  return {
    exercises: (await exerciseResponse.json()) as Exercise[],
    taxonomy: (await taxonomyResponse.json()) as Taxonomy
  };
}
